import { useEffect, useState } from 'react';

import { GetSessionVideo } from '@/connection/content/videos';
import { StaticVideo } from '@/types/video.types';
import toastTrigger from '@ui/toast/toast-trigger';

const useGetSessionVideo = (channel: number | null, videoUuid: string | null, sessionUuid?: string) => {
  const [sessionVideoData, setSessionVideoData] = useState<StaticVideo | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSessionVideoData(null);
  }, [sessionUuid]);

  useEffect(() => {
    setSessionVideoData(null);

    if (!channel || !videoUuid) {
      return;
    }

    setLoading(true);

    (async () => {
      try {
        const result = await GetSessionVideo(channel, videoUuid);
        setSessionVideoData(result);
      } catch (error) {
        console.error('Error fetching session video:', error);
        toastTrigger(<div className="S1">Error loading session video</div>, { type: 'error' });
      } finally {
        setLoading(false);
      }
    })();
  }, [channel, videoUuid]);

  return { sessionVideoData, loading };
};

export default useGetSessionVideo;
